import type { SVGProps } from 'react';

/**
 * Brand mark for GuestRise Tickets — the GuestRise "G" on a navy→black gradient
 * with a small gold accent dot.
 */
export function LogoMark({ size = 32, ...rest }: SVGProps<SVGSVGElement> & { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...rest}
    >
      <rect width="64" height="64" rx="14" fill="url(#guestrise-grad)" />
      <path
        d="M32 14a18 18 0 1 0 17.5 21.6h-12.2a6.4 6.4 0 1 1 .2-6.6H49A18 18 0 0 0 32 14Z"
        fill="#ffffff"
      />
      <circle cx="46.5" cy="32" r="2.4" fill="#d4af37" />
      <defs>
        <linearGradient id="guestrise-grad" x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
          <stop stopColor="var(--brand-navy, #14213d)" />
          <stop offset="1" stopColor="var(--brand-black, #000000)" />
        </linearGradient>
      </defs>
    </svg>
  );
}

/**
 * Full wordmark — mark + "GuestRise / Tickets" type set in the system stack.
 */
export function LogoWordmark({ className }: { className?: string }) {
  return (
    <span className={className} style={{ display: 'inline-flex', alignItems: 'center', gap: 10 }}>
      <LogoMark size={28} />
      <span style={{ display: 'inline-flex', flexDirection: 'column', lineHeight: 1 }}>
        <strong style={{ fontSize: '0.6875rem', letterSpacing: '0.18em', textTransform: 'uppercase', color: 'var(--brand-gold, #d4af37)', fontWeight: 700 }}>
          GuestRise
        </strong>
        <strong style={{ fontSize: '1.0625rem', letterSpacing: '-0.02em', fontWeight: 700 }}>
          Tickets
        </strong>
      </span>
    </span>
  );
}
